import dynamic from 'next/dynamic'

export const HomepageHero = dynamic(() => import('./homepage-hero'))
